<template>
  <section>
    <div class="container details-products">
      <div class="container">
        <div class="product-header">
          <div class="row">
            <div
              class="col-lg-6 col-md-6 col-sm-6 col-12 py-3 align-self-center"
            >
              <b-breadcrumb
                :items="itemsBread"
                class="bread-product nomov2"
              ></b-breadcrumb>
            </div>
            <div
              class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3 py-3 align-self-center"
            >
              <div class="contact alinmov3">
                <span>
                  <i class="flaticon-telephone mr-2"></i>Book online or call:
                  <a href="#" class="link-contact">+1 312 5440151</a>
                </span>
              </div>

              <div class="contact">
                <span
                  class="link-contact d-inline-block"
                  @click="openChatSuport()"
                >
                  <i class="flaticon-chat-1 mr-2"></i><strong>Chat Now</strong>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="products">
          <div class="row">
            <div class="col-12 header">
              <h1 class="title">{{ product.name }}</h1>

              <div class="row info-content">
                <div class="col-xl-9 col-lg-9 col-md-9 col-dsm-9 col-12">
                  <div class="review">
                    <!-- <span class="min-reviews">
                      <i class="flaticon-star-2 star"></i>
                      3k Reviews</span
                    >
                    <span class="min-separator">|</span> -->
                    <span class="location">
                      <router-link to=""
                        >{{ product.branch.name }}
                      </router-link>
                    </span>
                  </div>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 alinmov3"
                >
                  <div class="box-share-top">
                    <span class="inline-flex mr-2">Share: </span>

                    <el-tooltip content="Copy Link" placement="bottom">
                      <a href="#" class="inline-flex mr-2"
                        ><i class="flaticon-copy"></i
                      ></a>
                    </el-tooltip>

                    <el-tooltip content="Email" placement="bottom">
                      <a href="#" class="inline-flex mr-2"
                        ><i class="flaticon-envelope"></i
                      ></a>
                    </el-tooltip>

                    <el-tooltip content="Whatsapp" placement="bottom">
                      <a href="#" class="inline-flex"
                        ><i class="flaticon-whatsapp"></i
                      ></a>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12 mb-4">
              <div class="image-slide-experiences">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <base-button type="link" class="b-next" @click="next"
                      ><i class="flaticon-web-right-chevron"></i
                    ></base-button>
                    <base-button type="link" class="b-prev" @click="prev"
                      ><i class="flaticon-web-left-chevron"></i
                    ></base-button>
                    <b-carousel
                      id="productsCarousel"
                      ref="productsCarousel"
                      v-model="imgCarousel"
                      :interval="0"
                      :controls="false"
                      img-width="1024"
                      img-height="480"
                      @sliding-start="onSlideStart"
                      @sliding-end="onSlideEnd"
                      class="carousel-products"
                    >
                      <template #prev>
                        <button @click="prev">Anterior</button>
                      </template>
                      <b-carousel-slide
                        v-for="(image, i) in product.images"
                        :key="i"
                      >
                        <template #img>
                          <LazyImage
                            :src="image"
                            :alt="`${product.name}-${i}`"
                            imgClasses="image-slider"
                          />
                        </template>
                      </b-carousel-slide>
                    </b-carousel>
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-sm-block d-none"
                  >
                    <div class="slide-products">
                      <div
                        class="container-img"
                        v-for="(image, i) in product.images"
                        :key="i"
                      >
                        <div
                          class="overlay"
                          :class="{ active: imgCarousel === i }"
                          @click="changeCarousel(i)"
                        ></div>

                        <LazyImage :src="image" :alt="`${product.name}-${i}`" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-12 mb-3">
              <div class="card content-price mt-xl-0 mt-lg-0 mt-md-2 mt-sm-4">
                <span class="amount-price"
                  >From
                  <strong class="strong"
                    ><span class="f-20">{{ product.currency.symbol }}</span>
                    {{ product.pricing.amount }}
                    <span class="f-20">
                      {{ product.currency.code }}</span
                    ></strong
                  ></span
                >
                <span class="info-price">Price varies by group size</span>
                <hr />
                <h2 class="subtitle-book">Select Date, Time and Passengers</h2>

                <div class="row">
                  <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 pr-0">
                    <div class="input-group flackpick-group with-append mb-2">
                      <div class="input-group-prepend">
                        <i class="flaticon-calendar"></i>
                      </div>
                      <base-input
                        :error="$v.book.date.$error ? `Enter Date` : ''"
                        addon-left-icon="flaticon-calendar"
                        label=""
                        v-bind:class="{
                          'invalid-feedback-flatpicker': $v.book.date.$error
                        }"
                      >
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{
                            altInput: true,
                            dateFormat: 'Y-m-d',
                            allowInput: true
                          }"
                          class="input-custom "
                          v-model="$v.book.date.$model"
                          placeholder="DD-MM-YYYY"
                          id="date"
                          name="date"
                        ></flat-picker>
                      </base-input>
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12">
                    <div class="input-group flackpick-group with-append mb-2">
                      <div class="input-group-prepend">
                        <i class="flaticon-clock"></i>
                      </div>
                      <base-input
                        :error="$v.book.time.$error ? `Enter Time` : ''"
                        addon-left-icon="flaticon-clock-2"
                        label=""
                        v-bind:class="{
                          'invalid-feedback-flatpicker': $v.book.time.$error
                        }"
                      >
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{
                            altFormat: 'G:i K',
                            enableTime: true,
                            noCalendar: true,
                            dateFormat: 'G:i K',
                            time_24hr: false,
                            wrap: true
                          }"
                          class="input-custom form-control"
                          v-model="$v.book.time.$model"
                          id="time"
                          name="time"
                        ></flat-picker>
                      </base-input>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                    <div class="input-group flackpick-group">
                      <div class="input-group-prepend">
                        <i class="flaticon-team"></i>
                      </div>

                      <base-dropdown class="drop-one">
                        <base-button
                          type="none"
                          class="dropdown-toggle"
                          id="passenger_airport"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          slot="title-container"
                        >
                          {{ book.passengers }} Passengers
                        </base-button>

                        <div class="row">
                          <div class="col-12">
                            <label for="Passenger" class="label-fs-2">
                              You can select up to
                              {{ product.passengers.maximun }} Passengers in
                              total</label
                            >
                          </div>
                          <div
                            class="col-lg-6 align-self-center"
                            v-on:click.stop.prevent
                          >
                            <span class="min-max"
                              >Minimum: 1, Maximum:
                              {{ product.passengers.maximum }}</span
                            >
                          </div>
                          <div class="col-lg-6 align-self-center">
                            <ul class="selpass">
                              <li>
                                <base-button
                                  class="btn-circle"
                                  outline
                                  type="secondary"
                                  @click.stop.prevent="subtractPassengerCount()"
                                  >-</base-button
                                >
                              </li>
                              <li>
                                <span id="numberpassenger" class="number">
                                  {{ book.passengers }}
                                </span>
                              </li>
                              <li>
                                <base-button
                                  class="btn-circle"
                                  outline
                                  type="primary"
                                  @click.stop.prevent="addPassengerCount()"
                                  >+</base-button
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </base-dropdown>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <base-button
                    type="primary"
                    class="min-button mt-2"
                    @click="checkAvailability"
                  >
                    Check Availability
                  </base-button>
                </div>

                <!-- loader para cuando esta cargando el proceso de procesar disponibilidad -->
                <div class="loading mt-1" v-if="loadAvailability">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>

                <div class="beneficts">
                  <div
                    class="benefict"
                    v-for="(item, index) in benefits"
                    :value="item.value"
                    :label="item.title"
                    :key="`${index}`"
                  >
                    <div class="icon-b">
                      <i :class="item.icon"> </i>
                    </div>

                    <div class="content-b">
                      <label>{{ item.title }}</label>
                      <p v-html="item.description"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12 order-lg-1 order-md-2 order-sm-2 order-2"
            >
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                  <h2 class="subtitle">Related</h2>

                  <div class="row justify-content-center">
                    <div
                      class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12 mb-3"
                      v-for="(product, index) in products"
                      :key="index"
                    >
                      <cardVertical
                        :product="product"
                        :index="index"
                        :excerpt="false"
                        size="sm-column"
                        source="RHOMTRIP"
                      ></cardVertical>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-10 col-lg-9 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1"
            >
              <div class="product-details">
                <div class="overview">
                  <h2>Overview</h2>
                  <div class="mb-4" v-html="product.description"></div>

                  <div class="row">
                    <div
                      class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                    >
                      <div class="mt-4">
                        <h2>What's Included</h2>
                        <div class="row">
                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 "
                            v-for="(item, index) in product.inclusions"
                            :value="item"
                            :label="item"
                            :key="index"
                          >
                            <li class="inclusions">{{ item }}</li>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                    >
                      <div class="mt-4">
                        <h2>What's not Included</h2>
                        <div class="row">
                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                            v-for="(item, index) in product.exclusions"
                            :value="item"
                            :label="item"
                            :key="index"
                          >
                            <li class="exclusions">{{ item }}</li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4">
                    <h2>Important Information</h2>
                    <ul class="list">
                      <li
                        v-for="(item, index) in product.important_information"
                        :value="item"
                        :label="item"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>

                  <div class="mt-4">
                    <h2>Meeting Point</h2>
                    <ul class="list">
                      <li
                        v-for="(item, index) in product.meeting_points"
                        :value="item"
                        :label="item"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                  <div
                    class="mt-4"
                    v-if="product.additional_information.length"
                  >
                    <h2>Additional Information</h2>
                    <ul class="list">
                      <li
                        v-for="(item, index) in product.additional_information"
                        :value="item"
                        :label="item"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>

                  <div class="mt-4" v-if="product.keyDetails">
                    <h2>Key Details</h2>
                    <p>{{ product.keyDetails }}</p>
                  </div>

                  <div class="mt-4" v-if="product.cancellation_policy.length">
                    <h2>Cancellation Policy</h2>
                    <ul class="list">
                      <li
                        v-for="(item, index) in product.cancellation_policy"
                        :value="item"
                        :label="item"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>

                  <div class="mt-4" v-if="product.termsConditions">
                    <h2>Terms and Conditions</h2>
                    <p>{{ product.termsConditions }}</p>
                  </div>

                  <div v-if="product.tags.length" class="mt-4">
                    <ul class="tags pl-0">
                      <li v-for="(item, index) in product.tags" :key="index">
                        <router-link :to="'#'">
                          {{ item.name }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { ProductsAPI } from "../../../../../core/api";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import "vueperslides/dist/vueperslides.css";
import format from "date-fns/format";
import { required } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import ProductsCards from "../../../components/ProductsCards.vue";
import { BCarousel } from "bootstrap-vue";
import cardVertical from "../../../components/cards/CardVertical.vue";
import { goBack } from "../../../../../helpers/commons.helpers";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

const today = new Date();
export default {
  name: "PreviewProduct",
  data() {
    return {
      product: {
        name: "",
        code: "",
        service: {
          vehicle: {
            name: ""
          },
          ref: "",
          category: ""
        },
        quote: "AREA",
        type: "PRIVATE_TRANSFER",
        status: false,
        branch: {
          name: "",
          ref: null,
          primary: true
        },
        time_zone: "",
        passengers: {
          minimum: 1,
          maximum: 3
        },
        bags: {
          minimun: 1,
          maximun: 3
        },
        images: [],
        description: "",
        short_description: "",
        currency: {
          code: "USD",
          symbol: "",
          name: ""
        },
        reviews: {
          total: 0,
          rating: 0
        },
        supplier: {
          name: "",
          ref: null
        },
        area: {
          name: "",
          ref: null
        },
        pricing: {
          type: "UNIT",
          amount: 0
        },
        availability: "",
        cutoff: "",
        inclusions: [],
        exclusions: [],
        from: {
          address: "",
          type: ""
        },
        to: {
          address: "",
          type: ""
        },
        meeting_points: [],
        important_information: [],
        additional_information: [],
        cancellation_policy: [],
        tags: [],
        keyDetails: "",
        termsConditions: ""
      },
      services: [],
      inclusions: [
        {
          text: "60-minutes waiting time at the airport",
          value: "60-minutes waiting time at the airport"
        },
        {
          text: "24/7 customer service support",
          value: "24/7 customer service support"
        },
        { text: "Flight tracking", value: "flight tracking" },
        {
          text: "15-minutes waiting time",
          value: "15-minutes waiting time"
        },
        {
          text: "Bottle of water",
          value: "bottle of water"
        },
        {
          text: "Tolls and taxes",
          value: "tolls and taxes"
        },
        {
          text: "Gratuity",
          value: "gratuity"
        },
        {
          text: "Meet and greet",
          value: "meet and greet"
        },
        {
          text: "Additional items of luggage",
          value: "additional items of luggage"
        }
      ],
      exclusions: [
        {
          value: "food",
          text: "Food"
        },
        {
          value: "drinks",
          text: "Drinks"
        },
        {
          value: "additional items of luggage",
          text: "Additional items of luggage"
        },
        {
          value: "gratuity",
          text: "Gratuity"
        },
        {
          value: "parking fees",
          text: "Parking Fees"
        },
        {
          value: "meet & greet",
          text: "Meet & greet"
        },
        {
          value: "extra stop",
          text: "Extra Stop"
        },
        {
          value: "extra waiting time",
          text: "Extra waiting time"
        },
        {
          value: "child seats",
          text: "Child seats"
        }
      ],
      optionsFrom: [],
      optionsTo: [],
      destinations: [],
      areas: [],
      quote: "AREA",
      images: [],
      items: [
        {
          name: "Carnaval",
          from: "18 feb. 2022",
          end: "20 feb.2022",
          status: "active",
          _id: "1"
        },
        {
          name: "Crazy Days",
          from: "1 jan. 2022",
          end: "Never",
          status: "inactive",
          _id: "2"
        }
      ],
      book: {
        date: format(today, "YYYY-MM-DD"),
        passengers: 1,
        time: "12:00"
      },
      features: [
        {
          value: "pickup offered",
          text: "Pickup offered",
          icon: "flaticon-car"
        },
        {
          value: "mobile ticket",
          text: "Mobile ticket",
          icon: "flaticon-smartphone-1"
        },

        {
          text: "Support",
          value: "Support",
          icon: "flaticon-web-support"
        }
      ],
      benefits: [
        {
          value: "instant confirmation",
          title: "Instant Confirmation",
          icon: "flaticon-web-check-3",
          description:
            "You will receive an instant confirmation when you have completed your purchase."
        },
        {
          value: "pickup offered",
          title: "Pickup offered",
          icon: "flaticon-web-car-2",
          description: "We guarantee your pickup at the selected location."
        },
        {
          value: "Support",
          title: "Support",
          icon: "flaticon-web-support",
          description:
            "We offer support through all our communication channels."
        }
      ],
      imgCarousel: 0,
      sliding: null,
      loadAvailability: false,
      listOptions: false,
      products: [
        {
          name:
            "Private Round Trip Transfer from /to Los Angeles International Airport (LAX)",
          code: "1234",
          service: {
            vehicle: {
              name: "Ferrari"
            },
            ref: "1234",
            category: "Luxury"
          },
          quote: "AREA",
          type: "PRIVATE_TRANSFER",
          status: false,
          passengers: {
            minimun: "5",
            maximun: "6"
          },
          bags: {
            minimun: "1",
            maximun: "6"
          },
          images: [
            "https://upcdn.io/FW25b8h/raw/products/mercedes-benz-e-class-sedan-3seats-side-2-66qP.jpg"
          ],
          description: "",
          short_description:
            "Why spend your precious time waiting in long shuttle or taxi lines. Avoid the language barrier and currency exchange. Travel in style from",
          currency: {
            code: "USD",
            symbol: "$",
            name: ""
          },
          pricing: {
            type: "UNIT",
            amount: 165.35
          }
        },
        {
          name:
            "Private Round Trip Transfer from /to Los Angeles International Airport (LAX)",
          code: "1234",
          service: {
            vehicle: {
              name: "Ferrari"
            },
            ref: "1234",
            category: "Luxury"
          },
          quote: "AREA",
          type: "PRIVATE_TRANSFER",
          status: false,
          passengers: {
            minimun: "5",
            maximun: "6"
          },
          bags: {
            minimun: "1",
            maximun: "6"
          },
          images: [
            "https://upcdn.io/FW25b8h/raw/products/mercedes-benz-e-class-sedan-3seats-side-2-66qP.jpg"
          ],
          description: "",
          short_description:
            "Why spend your precious time waiting in long shuttle or taxi lines. Avoid the language barrier and currency exchange. Travel in style from",
          currency: {
            code: "USD",
            symbol: "$",
            name: ""
          },
          pricing: {
            type: "UNIT",
            amount: 165.35
          }
        },
        {
          name:
            "Private Round Trip Transfer from /to Los Angeles International Airport (LAX)",
          code: "1234",
          service: {
            vehicle: {
              name: "Ferrari"
            },
            ref: "1234",
            category: "Luxury"
          },
          quote: "AREA",
          type: "PRIVATE_TRANSFER",
          status: false,
          passengers: {
            minimun: "5",
            maximun: "6"
          },
          bags: {
            minimun: "1",
            maximun: "6"
          },
          images: [
            "https://upcdn.io/FW25b8h/raw/products/mercedes-benz-e-class-sedan-3seats-side-2-66qP.jpg"
          ],
          description: "",
          short_description:
            "Why spend your precious time waiting in long shuttle or taxi lines. Avoid the language barrier and currency exchange. Travel in style from",
          currency: {
            code: "USD",
            symbol: "$",
            name: ""
          },
          pricing: {
            type: "UNIT",
            amount: 165.35
          }
        }
      ]
    };
  },
  watch: {},
  async created() {
    this.producId = this.$route.params.id;
    await this.getProduct(this.producId);
    let bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "RhomTrip Experiences",
        to: "/experiences/rhomtrip"
      },
      {
        text: "Web Preview",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },

  methods: {
    async getProduct(producId) {
      try {
        let { data } = await ProductsAPI.getProductById(
          producId,
          this.sesion.token
        );
        if (data.status) {
          let product = data.data;
          this.product.name = product.name;
          this.images = this.getImages(product.images);
          this.product.images = product.images;
          this.product.code = product.code;
          this.product.quote = product.quote;
          this.quote = product.quote;
          this.product.service.ref = product.service.ref;
          this.product.service.category = product.service.category;
          this.product.service.vehicle.name = product.service.vehicle.name;
          this.services = [
            {
              vehicle: {
                name: product.service.vehicle.name
              },
              _id: product.service.ref
            }
          ];
          this.product.type = product.type;
          this.product.status = product.status;
          this.product.branch.name = product.branch.name;
          this.product.branch.ref = product.branch.ref;
          this.destinations = [
            {
              name: product.branch.name,
              _id: product.branch.ref,
              supplier: {
                name: product.supplier.name
              }
            }
          ];
          this.product.branch.primary = product.branch.primary;
          this.product.time_zone = product.time_zone;

          this.product.passengers.minimum = product.passengers.minimum;
          this.product.passengers.maximum = product.passengers.maximum;

          this.product.bags.minimum = product.bags.minimum;
          this.product.bags.maximum = product.bags.maximum;
          this.product.description = product.description;
          this.product.short_description = product.short_description;

          this.product.currency.code = product.currency.code;
          this.product.currency.symbol = product.currency.symbol;
          this.product.currency.name = product.currency.name;

          this.product.reviews.total = product.reviews.total;
          this.product.reviews.rating = product.reviews.rating;

          this.product.supplier.name = product.supplier.name;
          this.product.supplier.ref = product.supplier.ref;
          this.areas = [
            {
              _id: product.area.ref,
              name: product.area.name,
              price: product.pricing.amount
            }
          ];
          this.product.area.name = product.area.name;
          this.product.area.ref = product.area.ref;

          this.product.pricing.type = product.pricing.type;
          this.product.pricing.amount = product.pricing.amount;

          this.product.availability = product.availability;
          this.product.cutoff = product.cutoff;
          this.product.inclusions = product.inclusions;
          this.product.exclusions = product.exclusions;
          this.optionsFrom = [
            { select: product.from.address, type: product.from.type }
          ];
          this.product.from.address = product.from.address;
          this.product.from.type = product.from.type;
          this.optionsTo = [
            { select: product.to.address, type: product.to.type }
          ];
          this.product.to.address = product.to.address;
          this.product.to.type = product.to.type;

          this.product.meeting_points = product.meeting_points;
          this.product.important_information = product.important_information;
          this.product.additional_information = product.additional_information;
          this.product.cancellation_policy = product.cancellation_policy;
          this.product.tags = product.tags;
          this.product.termsConditions = product.termsConditions;
          this.product.keyDetails = product.keyDetails;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    addPassengerCount() {
      if (this.book.passengers < this.product.passengers.maximum) {
        this.book.passengers = this.book.passengers + 1;
      }
    },
    subtractPassengerCount() {
      if (this.book.passengers <= 0) {
        this.book.passengers = 0;
      } else {
        this.book.passengers = this.book.passengers - 1;
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    isInProductModule(modules = []) {
      if (!modules.includes("experiences")) {
        this.setProductSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    openChatSuport() {},
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    async checkAvailability() {
      try {
        let { data } = await ProductsAPI.availabilityCheck();
        if (data.status) {
          return false;
        } else {
          return true;
        }
      } catch (error) {
        return true;
      }
      // this.listOptions = true;
      // this.loadAvailability = true;
      // let { value } = await Swal.fire({
      // 	title: "No Availability",
      // 	html: "There is no availability for the selected date, please try again by changing the date",
      // 	imageUrl: "../img/icons/alerts/warning.png",
      // 	buttonsStyling: false,
      // 	showCloseButton: true,
      // 	showCancelButton: false,
      // 	focusConfirm: false,
      // 	reverseButtons: true,
      // 	cancelButtonText: "No",
      //
      // 	confirmButtonText: "Ok",
      //
      // });
      // if (value) {
      // 	this.loadAvailability = false;
      // }
    },
    prev() {
      this.$refs.productsCarousel.prev();
    },
    next() {
      this.$refs.productsCarousel.next();
    },
    changeCarousel(index) {
      this.$refs.productsCarousel.setSlide(index);
    },
    getImages(images = []) {
      return images.map(image => {
        let [name] = image
          .split("/")
          .pop()
          .split(".");
        return {
          url: image,
          name: name,
          uuid: name
        };
      });
    },
    ...mapActions(["getBranchsOptions"]),
    ...mapMutations(["setLoad", "setItemsBread", "setProductSearchCriteria"])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect,
    ProductsCards,
    "b-carousel": BCarousel,
    cardVertical
  },

  computed: {
    ...mapGetters([
      "branchsOptions",
      "sesion",
      "sigout",
      "settings",
      "itemsBread"
    ])
  },
  validations: {
    book: {
      date: {
        required
      },
      passengers: {
        required
      },
      time: {
        required
      }
    }
  },
  filters: {
    category: function(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    productTypes: function(type) {
      if (type === "EVENTE") {
        return "Event";
      } else if (type === "PRIVATE_TRANSFER") {
        return "Private Transfer";
      } else if (type === "ATTRACTION") {
        return "Attraction";
      } else if (type === "TOUR") {
        return "Tour";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInProductModule(to.meta.modules);
    next();
  }
};
</script>
